import { useQuery } from 'react-query';
import { JobDetails } from '../entities/JobDetails';
import { JobService } from '../services/JobService';

export const useJobDetails = (jobId?: number | string) =>
  useQuery<JobDetails>(
    ['jobs', jobId, 'details'],
    async () => {
      return jobId
        ? JobService.get(jobId.toString())
        : Promise.resolve({} as JobDetails);
    },
    {
      enabled: !!jobId,
    },
  );
